import { useMutation } from "@tanstack/react-query";
import { useQueryApi } from "api/hooks";

import { refuseLeadSettingsApi } from "./api";

import GetRefuseLeadSettingsRequest = App.Http.Requests.RefuseLeadSettings.GetRefuseLeadSettingsRequest;
import GetRefuseLeadSettingsResponse = App.Http.Responses.RefuseLeadSettings.GetRefuseLeadSettingsResponse;
import GetRefuseLeadSettingRequest = App.Http.Requests.RefuseLeadSettings.GetRefuseLeadSettingRequest;
import GetRefuseLeadSettingResponse = App.Http.Responses.RefuseLeadSettings.GetRefuseLeadSettingResponse;
import StoreRefuseLeadSettingRequest = App.Http.Requests.RefuseLeadSettings.StoreRefuseLeadSettingRequest;
import UpdateRefuseLeadSettingRequest = App.Http.Requests.RefuseLeadSettings.UpdateRefuseLeadSettingRequest;

export const useGetRefuseLeadSettings = (
    offerId: string,
    request: GetRefuseLeadSettingsRequest,
    options = {}
) => {
    return useQueryApi<GetRefuseLeadSettingsResponse>({
        queryKey: ["getRefuseLeadSettings", offerId, request],
        queryFn: () => refuseLeadSettingsApi.index(offerId, request),
        ...options,
    });
};

export const useGetRefuseLeadSetting = (
    offerId: string,
    refuseLeadSettingId: string,
    request: GetRefuseLeadSettingRequest,
    options = {}
) => {
    return useQueryApi<GetRefuseLeadSettingResponse>({
        queryKey: ["getRefuseLeadSetting", offerId, refuseLeadSettingId, request],
        queryFn: () => refuseLeadSettingsApi.show(offerId, refuseLeadSettingId, request),
        ...options,
    });
};

export const useStoreRefuseLeadSettingMutation = (offerId: string) => {
    return useMutation({
        mutationFn: (request: StoreRefuseLeadSettingRequest) => refuseLeadSettingsApi.store(offerId, request),
    });
};

export const useUpdateRefuseLeadSettingMutation = (offerId: string, refuseLeadSettingId: string) => {
    return useMutation({
        mutationFn: (request: UpdateRefuseLeadSettingRequest) =>
            refuseLeadSettingsApi.update(offerId, refuseLeadSettingId, request),
    });
};

export const useDestroyRefuseLeadSettingMutation = (offerId: string, refuseLeadSettingId: string) => {
    return useMutation({
        mutationFn: () => refuseLeadSettingsApi.destroy(offerId, refuseLeadSettingId),
    });
};
